import { render, staticRenderFns } from "./P17GarbageExcelReport.vue?vue&type=template&id=bd11c16c&"
import script from "./P17GarbageExcelReport.vue?vue&type=script&lang=js&"
export * from "./P17GarbageExcelReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports